import { render } from "./CodeFragment.vue?vue&type=template&id=26c527ee&ts=true"
import script from "./CodeFragment.vue?vue&type=script&lang=ts"
export * from "./CodeFragment.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__